<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 條件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="優惠券名稱" prop="name">
                <a-input v-model="queryParam.name" placeholder="請輸入優惠券名稱" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="店鋪名稱" prop="storeId">
                <a-input v-model="queryParam.storeName" placeholder="請輸入店鋪名稱" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查詢</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <coupen-user
        ref="coupenUser"
        @ok="getList"
      />

      <!-- 數據展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="dueTime" slot-scope="text, record">
          {{ parseTime(record.dueTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.coupenUser.show(record)" v-if="record.applicationStatus != 0 && record.applicationStatus != 2">
             申領記錄
          </a>
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-if="roleId == 2 && record.applicationStatus == 0">
             審核
          </a>
        </span>
      </a-table>
      <!-- 分頁 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 條`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageCoupon,listCoupon, delCoupon } from '@/api/platform/coupon'
import CreateForm from './modules/CreateForm'
import CoupenUser from './coupenUser'
import { tableMixin } from '@/store/table-mixin'
import request from "@/utils/request";

export default {
  name: 'Coupon',
  components: {
    CreateForm,
    CoupenUser
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      roleId: null,
      selectedRowKeys: [],
      selectedRows: [],
      // 高級搜索 展開/關閉
      advanced: false,
      // 非單個禁用
      single: true,
      // 非多個禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查詢參數
      queryParam: {
        name: null,
        minMoney: null,
        derateMoney: null,
        storeId: null,
        status: null,
        dueTime: null,
        applicationStatus: null,
        refusalCause: null,
        maxNum: null,
        surplusNum: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '優惠券名稱',
          dataIndex: 'name',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '最低消費金額',
          dataIndex: 'minMoney',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '減免金額',
          dataIndex: 'derateMoney',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '店鋪名稱',
          dataIndex: 'storeName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '狀態',
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
          customRender: function (value, record) {
            if (value == 0) {
              return "正常"
            }
            if (value == 1) {
              return "停用"
            }
          }
        },
        {
          title: '到期時間',
          dataIndex: 'dueTime',
          scopedSlots: { customRender: 'dueTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '總數量',
          dataIndex: 'maxNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '剩餘數量',
          dataIndex: 'surplusNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '申請狀態',
          dataIndex: 'applicationStatus',
          ellipsis: true,
          align: 'center',
          customRender: function (value, record) {
            if (value == 0) {
              return "待審核"
            }
            if (value == 1) {
              return "已同意"
            }
            if (value == 2) {
              return "已拒絕"
            }
            if (value == 3) {
              return "領取完"
            }
            if (value == 4) {
              return "已過期"
            }
          }
        },
        {
          title: '拒絕原因',
          dataIndex: 'refusalCause',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '插入時間',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
    this.getRole()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查詢優惠券-信息列表 */
    getList () {
      this.loading = true
     pageCoupon(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    getRole(){
      let that = this;
      request({
        url: '/system/user/getRole',
        method: 'post'
      }).then(response => {
        that.roleId = response.data;
      })
    },
    /** 搜索按鈕操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按鈕操作 */
    resetQuery () {
      this.queryParam = {
        name: undefined,
        minMoney: undefined,
        derateMoney: undefined,
        storeId: undefined,
        status: undefined,
        dueTime: undefined,
        applicationStatus: undefined,
        refusalCause: undefined,
        maxNum: undefined,
        surplusNum: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 刪除按鈕操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '確認刪除所選中數據?',
        content: '當前選中編號為' + ids + '的數據',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delCoupon(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '刪除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空刪除ids列表
          that.ids = []
        }
      })
    },
    /** 導出按鈕操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否確認導出?',
        content: '此操作將導出當前條件下所有數據而非選中數據',
        onOk () {
          that.download('platform/coupon/export', {
            ...that.queryParam
          }, `優惠券-信息_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
